const config= {
    baseUrl: process.env.REACT_APP_BASE_API,
    baseUrlCp: process.env.REACT_APP_BASE_CP_API,
    calculatorUrl: process.env.REACT_APP_BASE_CALCULATOR_API,
    calqueAI: process.env.REACT_APP_AI_API
}
export default config
